<template>
    <div :class="statusBuilder('TableSidebar', status)">
        <div class="TableSidebar__header-bar">
            <div class="TableSidebar__header-actions">
                <!-- @slot TableSidebar actions -->
                <slot name="actions"></slot>
                <!--
                    Prompt to close TableSidebar which must be done from parent
                    @event close-TableSidebar
                -->
                <button
                    class="TableSidebar__close-icon"
                    @click="$emit('close-TableSidebar')"
                >
                    <StreamlineIcon
                        :icon="Close"
                        :size="16"
                        :fill="textGrey"
                    />
                </button>
            </div>
            <!-- @slot TableSidebar header text -->
            <slot name="header">
                <h4>{{ sidebarHeader }}</h4>
            </slot>
        </div>
        <div class="TableSidebar__body">
            <template v-if="!isLoading">
                <!-- @slot primary TableSidebar content slot -->
                <slot></slot>
            </template>
        </div>
    </div>
</template>

<script>
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import stat from 'status/index';
import statusBuilder from 'status/statusBuilder';
import {Close} from "@reviewpush/streamline-bold/lib/interface-essential/FormValidation";
import {textGrey} from 'style/_colors.scss';

export default {
    name: "TableSidebar",
    components: {
        StreamlineIcon
    },
    props: {
        sidebarHeader: {
            type: String,
            default: '',
        },
        status: {
            type: String,
            default: stat.STANDBY,
        },
    },
    data() {
        return {
            Close,
            textGrey
        };
    },
    computed: {
        isLoading() {
            return this.status=== stat.LOADING;
        }
    },
    methods: {
        statusBuilder
    }
};
</script>
<style lang="scss">
    .TableSidebar {
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
        background: $white;
        border-radius: 4px;
        padding: 1.5rem;

        @include loading(100%, 100%);

        &__header-bar {
            display:flex;
            justify-content: space-between;
            flex-direction: row-reverse;
            align-items: center;
            margin-bottom: 1rem;
        }
        &__header-actions {
            display: flex;
            align-items: center;
        }
        &__close-icon{
            margin-left: 1rem;
        }
    }
</style>